import { render, staticRenderFns } from "./NoSuggestedListing.vue?vue&type=template&id=70418854&scoped=true&"
import script from "./NoSuggestedListing.vue?vue&type=script&lang=ts&"
export * from "./NoSuggestedListing.vue?vue&type=script&lang=ts&"
import style0 from "./NoSuggestedListing.vue?vue&type=style&index=0&id=70418854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70418854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VImg,VTextField})
